import React, { useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import "./Select.scss";

function Select({ list, onSaveList }) {
  const [open, setOpen] = useState(false);
  const toggler = () => {
    setOpen(!open);
  };

  const dropDownStatus = open ? "block" : "none";

  function chartListHandler(e) {
    const selectedItem = e.target.value;
    const ChartList = list.map((object) => {
      if (object.marketName === selectedItem) {
        return { ...object, cheked: !object.cheked };
      }
      return object;
    });
    onSaveList(ChartList);
  }

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <div className="Select-flink">
      <ClickAwayListener onClickAway={handleClickAway}>
        <div className="dropdown">
          <button className="btn  dropdown-toggle" onClick={toggler}>
            NL Power Forward
          </button>
          <ul
            style={{ display: `${dropDownStatus}` }}
            className="dropdown-menu "
          >
            {list.map((item, index) => {
              return (
                <li className="dropdown-item" key={index}>
                  <div>
                    <input
                      onChange={chartListHandler}
                      checked={item.cheked}
                      className="form-check-input "
                      type="checkbox"
                      value={item.marketName}
                      id={item.marketName}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={item.marketName}
                    >
                      {item.marketName}
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </ClickAwayListener>
    </div>
  );
}

export default Select;
